import { jsx } from "react/jsx-runtime";
import MailIcon from "@mui/icons-material/Mail";
import { validateTidalLicense } from "../../base/index.js";
function Mail(props) {
  return /* @__PURE__ */ jsx(
    MailIcon,
    {
      "data-testid": "Mail",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Mail",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Mail.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Mail"
};
validateTidalLicense();
export {
  Mail
};
//# sourceMappingURL=Mail.js.map
